module.exports = __webpack_public_path__ + "static/img/13.a38a7238.png";